import { useEffect, useState } from 'react';
import api from '../../../../api';
import './Library.css';
import DynamicBanner from '../../include/DynamicBanner';
import LatestNewsMarquee from './Partials/LatestNewsMarquee';
import StickyNav from './Partials/StickyNav';

const Policy = () => {
  const [policyData, setPolicyData] = useState(null);
  const [loading, setLoading] = useState(true);

  // Helper: always convert value to an array
  const toArray = (value) => {
    if (!value) return [];
    if (Array.isArray(value)) return value;
    if (typeof value === 'object') {
      // Handles objects like {0: 'a', 1: 'b'} or {someKey: {...}}
      return Object.keys(value)
        .sort()
        .map((key) => value[key]);
    }
    return [value]; // single scalar
  };

  useEffect(() => {
    const fetchPolicyData = async () => {
      try {
        const response = await api.get('/api/sitepages/about-us/librarypolicy');
        const data = response.data;
        setPolicyData(data);
        setLoading(false);
      } catch (err) {
        console.error('Error fetching policy data:', err);
        setLoading(false);
      }
    };

    fetchPolicyData();
  }, []);

  // Tab events (unchanged design, only data path updated)
  useEffect(() => {
    if (!loading && policyData) {
      const policySection = policyData.policy_section || {};
      const sections = toArray(policySection.sections);

      if (!sections || sections.length === 0) return;

      const tabEls = document.querySelectorAll(
        'section.d-md-block.policysection .sidebar a[data-bs-toggle="pill"]'
      );

      const handleTabShow = () => {};

      tabEls.forEach((tab) => {
        tab.addEventListener('shown.bs.tab', handleTabShow);
      });

      return () => {
        tabEls.forEach((tab) => {
          tab.removeEventListener('shown.bs.tab', handleTabShow);
        });
      };
    }
  }, [loading, policyData]);

  const renderContent = (section) => {
    const type = section?.type;

    switch (type) {
      case 'list': {
        const items = toArray(section.content);
        return (
          <ul className="list-ul">
            {items.map((item, index) => (
              <li key={index}>
            
                  <i className="fa fa-dot-circle-o"></i>
          
                {item}
              </li>
            ))}
          </ul>
        );
      }

      case 'tables': {
        const tables = toArray(section.tables);
        const extraItems = toArray(section.extra);

        return (
          <>
            {tables.map((table, tableIndex) => {
              const headers = toArray(table?.headers);
              const rows = toArray(table?.rows);

              return (
                <div key={tableIndex}>
                  <table className="timings-table">
                    <thead>
                      <tr>
                        {headers.map((header, headerIndex) => (
                          <th key={headerIndex}>{header}</th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {rows.map((row, rowIndex) => {
                        const cells = toArray(row);
                        return (
                          <tr key={rowIndex}>
                            {cells.map((cell, cellIndex) => (
                              <td
                                key={cellIndex}
                                className={cell === 'Closed' ? 'closed-text' : ''}
                              >
                                {cell}
                              </td>
                            ))}
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>

                  {tableIndex === 0 && extraItems.length > 0 && (
                    <ul className="list-ul mt-3">
                      {extraItems.map((item, index) => (
                        <li key={index}>
                        
                            <i className="fa fa-dot-circle-o"></i>
                      
                          {item}
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              );
            })}
          </>
        );
      }

      case 'lists': {
        const groups = toArray(section.content);

        return (
          <>
            {groups.map((listGroup, groupIndex) => {
              if (!listGroup) return null;

              const heading = listGroup.heading || '';
              const items = toArray(listGroup.items);

              return (
                <div key={groupIndex}>
                  {heading && <strong>{heading}</strong>}
                  <ul className="list-ul">
                    {items.map((item, index) => (
                      <li key={index}>
                    
                          <i className="fa fa-dot-circle-o"></i>
                
                        {item}
                      </li>
                    ))}
                  </ul>
                </div>
              );
            })}
          </>
        );
      }

      default:
        return null;
    }
  };

  if (loading) {
    return <>Loading</>;
  }

  if (!policyData) {
    return <>Error loading policy data</>;
  }

  // New response shape integration
  const banner = policyData.banner_data || {};
  const policySection = policyData.policy_section || {};
  const footer = policyData.footer_section || {};

  const sections = toArray(policySection.sections);
  const sidebarTitle = policySection.title || '';

  return (
    <>
      <section className="library-page">
       <DynamicBanner
  title={banner.title || 'Library Policy'}
  bgImage={toArray(banner.desktop_banner_images)}
  bgImageMobile={toArray(banner.mobile_banner_images)}
/>

        <LatestNewsMarquee />
        <StickyNav />

        {/* Desktop view */}
        <div className=" d-md-block d-none policysection">
          <div className="sec-title text-center">
            <h2>POLICY</h2>
          </div>
          <div className="container">
            <div className="nss-container">
              <div className="sidebar">
                <h4>{sidebarTitle}</h4>
                <div
                  className="nav flex-column nav-pills v-pills-tab-policy"
                  id="v-pills-tab"
                  role="tablist"
                  aria-orientation="vertical"
                >
                  {sections.map((section, index) => (
                    <a
                      key={section.id || `${index}`}
                      className={`nav-link ${index === 0 ? 'active' : ''}`}
                      data-bs-toggle="pill"
                      href={`#${section.id || `section-${index}`}`}
                      role="tab"
                      aria-controls={section.id || `section-${index}`}
                    >
                      {section.title}
                    </a>
                  ))}
                </div>
              </div>

              <div className="content-area">
                <div
                  className="tab-content tab-library-style"
                  id="v-pills-tabContent"
                >
                  {sections.map((section, index) => (
                    <div
                      key={section.id || `${index}`}
                      className={`tab-pane tab-css fade ${
                        index === 0 ? 'show active' : ''
                      } list`}
                      id={section.id || `section-${index}`}
                      role="tabpanel"
                    >
                      <h3>{section.title}</h3>
                      {renderContent(section)}
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Mobile view */}
        <div className=" pb_80 d-block d-md-none policysection">
          <div className="container">
            <div className="sec-title text-center">
              <h2>POLICY</h2>
            </div>

            <div className="accordion" id="policyAccordion">
              {sections.map((section, index) => (
                <div key={section.id || `${index}`} className="accordion-item">
                  <h2
                    className="accordion-header"
                    id={`heading-${section.id || `section-${index}`}`}
                  >
                    <button
                      className={`accordion-button ${
                        index !== 0 ? 'collapsed' : ''
                      }`}
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target={`#collapse-${section.id || `section-${index}`}`}
                      aria-expanded={index === 0}
                      aria-controls={`collapse-${section.id || `section-${index}`}`}
                    >
                      {section.title}
                    </button>
                  </h2>
                  <div
                    id={`collapse-${section.id || `section-${index}`}`}
                    className={`accordion-collapse collapse ${
                      index === 0 ? 'show' : ''
                    }`}
                    aria-labelledby={`heading-${section.id || `section-${index}`}`}
                    data-bs-parent="#policyAccordion"
                  >
                    <div className="accordion-body">
                      {renderContent(section)}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Footer image section (same design, dynamic data) */}
        <div className="pt_80">
          <div className="container">
            <div className="row d-flex justify-content-center align-items-center">
              <div className="col-md-4 text-center">
                <h6 className="text-left">
                  {footer.image_title || 'Smoke and tobacco-free Environment'}
                </h6>
                <img
                  src={`${process.env.REACT_APP_API_URL}/public${footer.image_url}` || 'https://care.edu.in/wp-content/uploads/2020/09/tobacco.jpg'}
                  alt={footer.image_title || 'Smoke and tobacco-free environment'}
                />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Policy;
